export default __webpack_public_path__ + "static/header-1ccbe66b270696cd7ff8a558c2ca7461.webp";